import {
  ContainerClient,
  ImageStoreDTO,
  OrphanImagesClient,
  OrphanImagesResultDTO,
  SavePlateTypeDTO,
} from 'business/models/Models';
import BaseService from './BaseService';
import ModelFactory from 'business/models/ModelFactory';

export default class PlateTypeService extends BaseService {
  async getAllPlateTypes() {
    const containerClient: ContainerClient = ModelFactory(ContainerClient, false, true);
    return await containerClient.getAll();
  }
  async saveAllPlateTypes(savePlateTypeDTO: SavePlateTypeDTO) {
    const containerClient: ContainerClient = ModelFactory(ContainerClient, false, true);
    return await containerClient.save(savePlateTypeDTO);
  }
  async findAllOrphanImages(imageStoreList: ImageStoreDTO[]) {
    const orphanImagesClient: OrphanImagesClient = ModelFactory(
      OrphanImagesClient,
      false,
      true,
    );
    return await orphanImagesClient.searchOrphanImages(imageStoreList);
  }
  async moveOrphanImagesToArchive(orphanImagesList: OrphanImagesResultDTO[]) {
    const orphanImagesClient: OrphanImagesClient = ModelFactory(
      OrphanImagesClient,
      false,
      true,
    );
    return await orphanImagesClient.moveOrphanImagesToArchive(orphanImagesList);
  }
}
